export function pushEvent(event) {
    console.debug('pushEvent', event);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
}

if (typeof window !== 'undefined') {
    window.mannington = window.mannington || {};
    window.mannington.pushEvent = pushEvent;
}